"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var updateConversationsCategoriesInternal_1 = require("./helpers/updateConversationsCategoriesInternal");
var legacy_1 = require("satcheljs/lib/legacy");
var datapoints_1 = require("../datapoints");
/**
 * Add categories to the specified rows from the table
 * @param rowKeys of the rows to add categories to
 * @param tableView that contains the rows
 * @param categoriesToAdd the categories to be added to the rows
 * @param actionSource the action source
 */
exports.addCategoriesFromTable = legacy_1.action('addCategories', datapoints_1.default.addCategories)(function addCategoriesFromTable(rowKeys, tableView, categoriesToAdd, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, categoriesToAdd, null /* categoriesToRemove */, false /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
/**
 * Clear categories of the specified rows from the table
 * @param rowKeys of the rows to clear categoriesToRemove
 * @param tableView that contains the rows
 * @param actionSource the action source
 */
exports.clearCategoriesFromTable = legacy_1.action('clearCategories', datapoints_1.default.clearCategories)(function clearCategoriesFromTable(rowKeys, tableView, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, null /* categoriesToAdd */, null /* categoriesToRemove */, true /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
/**
 * Remove categories from the specified rows from the table
 * @param rowKeys of the rows to remove categories to
 * @param tableView that contains the rows
 * @param categoriesToRemove the categories to be removed to the rows
 * @param actionSource the action source
 */
exports.removeCategoriesFromTable = legacy_1.action('removeCategoriesFromTable', datapoints_1.default.removeCategories)(function removeCategoriesFromTable(rowKeys, tableView, categoriesToRemove, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            updateConversationsCategoriesInternal_1.default(rowKeys, tableView, null /* categoriesToAdd */, categoriesToRemove, false /* clearCategories */, actionSource);
            break;
        case 1 /* Message */:
            break;
    }
});
//# sourceMappingURL=categoryTriageActions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/categories/categoryTriageActions.js
// module id = 5666
// module chunks = 62